var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarChartBoxLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3889_2173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 2.97461H15.75C15.9489 2.97461 16.1397 3.05363 16.2803 3.19428C16.421 3.33493 16.5 3.5257 16.5 3.72461V15.7246C16.5 15.9235 16.421 16.1143 16.2803 16.2549C16.1397 16.3956 15.9489 16.4746 15.75 16.4746H2.25C2.05109 16.4746 1.86032 16.3956 1.71967 16.2549C1.57902 16.1143 1.5 15.9235 1.5 15.7246V3.72461C1.5 3.5257 1.57902 3.33493 1.71967 3.19428C1.86032 3.05363 2.05109 2.97461 2.25 2.97461ZM3 4.47461V14.9746H15V4.47461H3ZM5.25 10.4746H6.75V13.4746H5.25V10.4746ZM8.25 5.97461H9.75V13.4746H8.25V5.97461ZM11.25 8.22461H12.75V13.4746H11.25V8.22461Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3889_2173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.724609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartBoxLine);
export default __webpack_public_path__ + "static/media/bar-chart-box-line.45ba1207afbb01d6ca8a2559a6e9fe90.svg";
export { ForwardRef as ReactComponent };